module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Copyright © 2001 by Dagoberto Gilb"), _c('br'), _vm._v("Illustrations copyright © 2001 by Artemio Rodriguez")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Gilb, Dagoberto, 1950-")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Woodcuts of women/Dagoberto Gilb.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightc"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Contents: Maria de Covina — Mayela one day in 1989 — Hueco — Shout — The pillows — About Tere who was in Palomas — Brisa — A painting in Sante Fe — Bottoms — Snow.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("eBook ISBN-13: 978-1-5558-4636-7")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("1. Mexican American women —Fiction. 2. Southwestern States — Social life and customs —Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("PS3557.I296 W6 2001"), _c('br'), _vm._v("813′.54-dc21                                                                                    00-060060")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Design by Julie Duquet")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("GROVE PRESS"), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06aa9c8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_copy.vue
// module id = 75
// module chunks = 0